module.exports = ".tat_img {\r\n  border: 1px solid;\r\n  border-radius: 50%;\r\n  padding: 5px;\r\n}\r\n"